export var ORDER_ASCENDING = 'ORDER_ASCENDING';
export var ORDER_DESCENDING = 'ORDER_DESCENDING';
export var HEADER_ROW_HEIGHT = 44;
export var ROW_HEIGHT = 44;
export var DEFAULT_COLUMN_WIDTH = 150;
export var SELECT_ROW_CHECKBOX_WIDTH = 16;
export var PREVIEW_ICON_WIDTH = 22;
export var ACTIONS_BTN_WIDTH = 25;
export var SPACING_BETWEEN_CONTROLS = 10;
export var CONTROLS_ROW_PADDING = 18;
export var NULL = 'NULL';